import {type CertificationBundle} from '@udemy/react-certification-preparation';

/**
 * Selects the bundle for a cart voucher from `bundlesByTopicId` results.
 *
 * Topic bundles carry complete course data. When multiple bundles share a topic,
 * `bundlesByBundleItem` (voucher exam) is used only to identify the matching
 * bundle id — not as the source of course contents.
 */
export function pickBundleForVoucherExam(
    topicBundles: CertificationBundle[],
    voucherExamBundle: CertificationBundle | undefined,
): CertificationBundle | undefined {
    if (!topicBundles.length) {
        return undefined;
    }

    if (topicBundles.length === 1) {
        return topicBundles[0];
    }

    if (!voucherExamBundle?.id) {
        return undefined;
    }

    return topicBundles.find((bundle) => bundle.id === voucherExamBundle.id);
}
